export default "__VITE_ASSET__7b610e9e__"